import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import MotionReveal from '../motion/MotionReveal';
import SectionProcessBg from '../components/SectionProcessBg';
import { ProductIcon } from '../components/icons/BrandIcons';
import { PRODUCT_LINES } from '../data/products';
import { staggerContainer } from '../motion/variants';

const cardEntrance = {
  hidden: { opacity: 0, y: 28 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: i * 0.08,
      ease: [0.22, 1, 0.36, 1],
    },
  }),
};

export default function ProductUniverseSection({ compact = false }) {
  const reduceMotion = useReducedMotion();
  return (
    <section
      id="products"
      className="sec sec-process-wrap pu-section"
      data-section-theme="products"
      data-palette="white"
    >
      <SectionProcessBg variant="extrusion" seed={3} />
      <div className="sec-process-content">
        <MotionReveal className="pu-hdr">
          <div>
            <div className="kicker k-gold">Product Universe</div>
            <h2 className="title lt">
              Four product lines,
              <br />
              <em>one technical partner</em>
            </h2>
          </div>
          {!compact && (
            <p className="pu-sub">
              Engineered to move color, performance and sustainability forward together — from laboratory formulation
              to your production line.
            </p>
          )}
        </MotionReveal>

        <motion.div
          className="pu-grid"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.12 }}
            >
              {PRODUCT_LINES.map((line, i) => (
                <motion.div
                  key={line.id}
                  className="pu-card pu-card--animated"
                  data-accent={line.accent}
                  custom={i}
                  variants={cardEntrance}
                  whileHover={
                    reduceMotion
                      ? undefined
                      : {
                          y: -10,
                          transition: { type: 'spring', stiffness: 320, damping: 22 },
                        }
                  }
                  whileTap={reduceMotion ? undefined : { scale: 0.98 }}
                >
                  <span className="pu-card__shine" aria-hidden="true" />
                  <div className="pu-card__icon">
                    <ProductIcon name={line.icon} size={28} />
                  </div>
                  <h3>{line.name}</h3>
                  <p className="pu-card__tag">{line.tagline}</p>
                  {!compact && <p className="pu-card__desc">{line.description}</p>}
                  {!compact && (
                    <div className="pu-card__solutions">
                      {line.solutions.map((s) => (
                        <span key={s}>{s}</span>
                      ))}
                    </div>
                  )}
                  <Link to={`/products#${line.id}`} className="pu-card__link">
                    Explore {line.name} →
                  </Link>
                </motion.div>
          ))}
        </motion.div>

        <MotionReveal className="pu-cta-bar">
          <p>
            <strong>One partner, end to end.</strong> From color matching to recyclable design — Auralux carries
            your product from lab to line.
          </p>
          <Link to="/contact" className="btn-p">
            Request a Sample
          </Link>
        </MotionReveal>
      </div>
    </section>
  );
}
